import { render, staticRenderFns } from "./TimesheetDashboardTab.vue?vue&type=template&id=487f124e&scoped=true"
import script from "./TimesheetDashboardTab.vue?vue&type=script&lang=js"
export * from "./TimesheetDashboardTab.vue?vue&type=script&lang=js"
import style0 from "./TimesheetDashboardTab.vue?vue&type=style&index=0&id=487f124e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f124e",
  null
  
)

export default component.exports